class SearchDropdownManager {
  constructor() {
    this.searchToggle = document.getElementById("search-toggle");
    this.searchDropdown = document.getElementById("search-dropdown");
    this.searchOverlay = document.getElementById("search-overlay");
    this.searchCloseButton = document.getElementById("search-close-button");
    this.searchMobileCloseButton = document.getElementById(
      "search-mobile-close-button"
    );
    this.searchInput = document.querySelector(".search__input");
    this.manualPredictiveSearch = document.querySelector(
      "manual-predictive-search"
    );

    this.init();
  }

  init() {
    this.initializeDropdown();
    this.bindEvents();
  }

  initializeDropdown() {
    if (this.searchDropdown) {
      this.searchDropdown.classList.remove("d-none");
      this.searchDropdown.classList.add("css-loaded", "ready");
      if (!document.body.classList.contains("css-ready")) {
        document.body.classList.add("css-ready");
      }
    }
  }

  bindEvents() {
    if (this.searchToggle && this.searchDropdown) {
      this.searchToggle.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleSearch();
      });
    }
    if (this.searchCloseButton) {
      this.searchCloseButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeSearch();
      });
    }
    if (this.searchMobileCloseButton) {
      this.searchMobileCloseButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeSearch();
      });
    }
    if (this.searchOverlay) {
      this.searchOverlay.addEventListener("click", () => {
        this.closeSearch();
      });
    }
    document.addEventListener("click", (e) => {
      if (
        this.isSearchActive() &&
        !this.searchDropdown.contains(e.target) &&
        !this.searchToggle.contains(e.target) &&
        !this.searchOverlay.contains(e.target)
      ) {
        this.closeSearch();
      }
    });
    if (this.searchInput) {
      this.searchInput.addEventListener("input", () => {
        if (this.searchInput.value) {
          this.searchInput.classList.add("has-content");
        } else {
          this.searchInput.classList.remove("has-content");
        }
      });
    }
  }

  toggleSearch() {
    if (this.isSearchActive()) {
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }

  openSearch() {
    if (!this.searchDropdown || !this.searchOverlay) return;
    this.searchDropdown.classList.add("active");
    this.searchOverlay.classList.add("active");
    this.searchToggle.setAttribute("aria-expanded", "true");
    document.body.classList.add("search-active");
    if (this.searchInput) {
      setTimeout(() => {
        this.searchInput.focus();
      }, 100);
    }
    if (this.manualPredictiveSearch) {
      this.manualPredictiveSearch.removeAttribute("results");
    }
  }

  closeSearch() {
    if (!this.searchDropdown || !this.searchOverlay) return;
    this.searchDropdown.classList.remove("active");
    this.searchOverlay.classList.remove("active");
    this.searchToggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("search-active");
    if (this.manualPredictiveSearch) {
      this.manualPredictiveSearch.removeAttribute("results");
    }
  }

  isSearchActive() {
    return (
      this.searchDropdown && this.searchDropdown.classList.contains("active")
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new SearchDropdownManager();
});
